import type SubjectTypeDefinitionFormData from '@UI/Pages/Administration/SubjectTypes/SubjectTypeEdit/FormData/SubjectTypeDefinitionFormData';
import type { WordingPart } from '@UI/Pages/Administration/SubjectTypes/SubjectTypeEdit/FormData/SubjectTypeDefinitionFormData';
import * as React from 'react';
import { InputText } from '@verclam/ui-kit';

type Props = {
	readonly formData: SubjectTypeDefinitionFormData;
	readonly onChange: (
		update: (formData: SubjectTypeDefinitionFormData) => SubjectTypeDefinitionFormData,
	) => void;
	readonly part: WordingPart;
	readonly label: string;
	readonly subLabel?: string;
	readonly required?: boolean;
	readonly disabled: boolean;
};

/** One text input of the wording, bound to its `part`, showing the server's message before the local one. */
const WordingInput: React.FC<Props> = ({ formData, onChange, part, label, subLabel, required, disabled }) => {
	const handleChange = React.useCallback(
		(value: string) => {
			onChange((current) => current.setWording(part, value));
		},
		[onChange, part],
	);

	return (
		<InputText
			name={part}
			label={label}
			subLabel={subLabel}
			required={required}
			disabled={disabled}
			value={formData[part]}
			onChange={handleChange}
			errorMessage={formData.getWordingErrorMessage(part)}
			isFormFieldValid={formData.isWordingShownValid(part)}
		/>
	);
};

export default WordingInput;
